<template>
  <div class="wrapper">
    <img
      v-show="showFuture"
      :style="image.style"
      class="image"
      :key="image.id"
      :src="image.src"
      v-for="image in addedTriangles"
    />
    <div class="main">
      <div class="section special-first-section-top">
        <div class="container">
          <div v-if="isMobileDevice" class="md-layout">
            <div class="md-layout-item md-size-55 md-small-size-100">
              <h1 class="title text-left">{{ $t("about.title") }}</h1>
              <h4 class="title-description text-left">
                {{ $t("about.description") }}
              </h4>
            </div>
            <div
              class="md-layout-item md-size-33 md-small-size-100 ml-auto"
              @mouseover="showFuture = true"
              @mouseout="showFuture = false"
            >
              <img :src="showFuture ? avatar_hover : avatar" />
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-button class="md-button" @click="openResume">{{
                $t("about.resume")
              }}</md-button>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-button class="md-button" href="mailto:stellachenyy@163.com">{{
                $t("about.hello")
              }}</md-button>
            </div>
          </div>

          <div v-else class="md-layout">
            <div class="md-layout-item md-size-55 md-small-size-100">
              <h1 ref="title" class="title text-left bottom">
                {{ $t("about.title") }}
              </h1>
              <h4 class="title-description text-left">
                {{ $t("about.description") }}
              </h4>
              <div class="md-layout margin-top-32">
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-button class="md-button" @click="openResume">{{
                    $t("about.resume")
                  }}</md-button>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-button
                    class="md-button"
                    href="mailto:stellachenyy@163.com"
                    >{{ $t("about.hello") }}</md-button
                  >
                </div>
              </div>
            </div>
            <div
              ref="avatar"
              class="md-layout-item md-size-33 md-small-size-100 ml-auto no-padding"
              @mouseover="showFuture = true"
              @mouseout="showFuture = false"
            >
              <img :src="showFuture ? avatar_hover : avatar" />
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="container">
          <div class="md-layout margin-bottom-64" ref="slogan">
            <div
              class="md-layout-item md-size-100 md-small-size-100 ml-auto"
              @mouseover="showFuture = true"
              @mouseout="showFuture = false"
            >
              <img :src="showFuture ? slogan_hover : slogan" />
            </div>
          </div>
          <div class="md-layout">
            <h3 class="title text-left">{{ $t("about.subtitle1") }}</h3>
          </div>
          <div class="md-layout margin-top-32">
            <div
              class="md-layout-item small-padding md-size-67 md-small-size-100"
            >
              <img
                :src="oil_paints[0].image"
                :large="oil_paints_large[0].image"
                preview="0"
              />
            </div>
            <div
              class="md-layout-item small-padding md-size-33 md-small-size-100"
            >
              <img
                :src="oil_paints[1].image"
                :large="oil_paints_large[1].image"
                preview="0"
              />
            </div>
          </div>
          <div class="md-layout margin-top-12">
            <div
              class="md-layout-item small-padding md-size-25 md-small-size-100"
            >
              <img
                class="image-full-width"
                :src="oil_paints[2].image"
                :large="oil_paints_large[2].image"
                preview="0"
              />
            </div>
            <div
              class="md-layout-item small-padding md-size-25 md-small-size-100"
            >
              <img
                class="image-full-width"
                :src="oil_paints[3].image"
                :large="oil_paints_large[3].image"
                preview="0"
              />
            </div>
            <div
              class="md-layout-item small-padding md-size-25 md-small-size-100"
            >
              <img
                class="image-full-width"
                :src="oil_paints[4].image"
                :large="oil_paints_large[4].image"
                preview="0"
              />
            </div>
            <div
              class="md-layout-item small-padding md-size-25 md-small-size-100"
            >
              <img
                class="image-full-width"
                :src="oil_paints[5].image"
                :large="oil_paints_large[5].image"
                preview="0"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="container">
          <div class="md-layout">
            <h3 class="title text-left">{{ $t("about.subtitle2") }}</h3>
          </div>
          <div class="md-layout margin-top-32">
            <div class="md-layout-item no-padding md-size-50 md-small-size-100">
              <img :src="studies[0].image" preview="0" />
            </div>
            <div class="md-layout-item no-padding md-size-50 md-small-size-100">
              <img :src="studies[1].image" preview="0" />
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="container about-section">
          <div class="md-layout">
            <h3 class="title text-left">{{ $t("about.subtitle3") }}</h3>
          </div>
          <div class="md-layout margin-top-32">
            <div class="md-layout-item no-padding md-size-50 md-small-size-100">
              <img :src="daydreamings[0].image" preview="0" />
            </div>
            <div class="md-layout-item no-padding md-size-50 md-small-size-100">
              <img :src="daydreamings[1].image" preview="0" />
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="container">
          <div class="md-layout">
            <h3 class="title text-left">{{ $t("about.subtitle4") }}</h3>
          </div>
          <div class="md-layout margin-top-32">
            <img :src="kudos" preview="0" />
          </div>
        </div>
      </div>
    </div>
    <!-- main-->
  </div>
  <!-- wrapper-->
</template>
<script>
export default {
  components: {},
  name: "about",
  bodyClass: "about-page",
  props: {
    avatar: {
      type: String,
      default: require("@/assets/img/about/avatar.png")
    },
    avatar_hover: {
      type: String,
      default: require("@/assets/img/about/avatar_hover.png")
    },
    kudos: {
      type: String,
      default: require("@/assets/img/about/kudos.png")
    },
    slogan: {
      type: String,
      default: require("@/assets/img/about/slogan.png")
    },
    slogan_hover: {
      type: String,
      default: require("@/assets/img/about/slogan_hover.png")
    },
    triangle_1: {
      type: String,
      default: require("@/assets/img/about/triangle_1.png")
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile,
      showFuture: false,
      oil_paints: [
        { image: require("@/assets/img/about/oil_paint_1.png") },
        { image: require("@/assets/img/about/oil_paint_2.png") },
        { image: require("@/assets/img/about/oil_paint_3.png") },
        { image: require("@/assets/img/about/oil_paint_4.png") },
        { image: require("@/assets/img/about/oil_paint_5.png") },
        { image: require("@/assets/img/about/oil_paint_6.png") }
      ],
      oil_paints_large: [
        { image: require("@/assets/img/about/oil_paint_large_1.png") },
        { image: require("@/assets/img/about/oil_paint_large_2.png") },
        { image: require("@/assets/img/about/oil_paint_large_3.png") },
        { image: require("@/assets/img/about/oil_paint_large_4.png") },
        { image: require("@/assets/img/about/oil_paint_large_5.png") },
        { image: require("@/assets/img/about/oil_paint_large_6.png") }
      ],
      studies: [
        { image: require("@/assets/img/about/study_1.png") },
        { image: require("@/assets/img/about/study_2.png") }
      ],
      daydreamings: [
        { image: require("@/assets/img/about/daydreaming_1.png") },
        { image: require("@/assets/img/about/daydreaming_2.png") }
      ],
      resume_name: "YingyingChen_Resume_" + this.$i18n.locale + ".pdf",
      baseUrl: process.env.BASE_URL,
      triangles: [
        { image: require("@/assets/img/about/triangle_1.png") },
        { image: require("@/assets/img/about/triangle_2.png") },
        { image: require("@/assets/img/about/triangle_3.png") },
        { image: require("@/assets/img/about/triangle_4.png") },
        { image: require("@/assets/img/about/triangle_5.png") }
      ],
      addedTriangles: [],
      imgTop: 0,
      imgLeft: 0,
      zIndex: 5,
      imgSize: 0
    };
  },
  computed: {},
  methods: {
    openResume() {
      window.open(this.baseUrl + this.resume_name, "_blank");
    },
    addTriangles() {
      this.imgTop = this.$refs.title.getBoundingClientRect().top - 58;
      this.imgLeft = this.$refs.title.getBoundingClientRect().left - 58;
      this.addedTriangles.push({
        style: {
          top: `${this.imgTop}px`,
          left: `${this.imgLeft}px`,
          zIndex: this.zIndex
        },
        src: this.triangles[0].image
      });
      this.imgTop = this.$refs.slogan.getBoundingClientRect().top;
      this.imgLeft = this.$refs.slogan.getBoundingClientRect().left - 96;
      this.addedTriangles.push({
        style: {
          top: `${this.imgTop}px`,
          left: `${this.imgLeft}px`,
          zIndex: this.zIndex
        },
        src: this.triangles[1].image
      });
      this.imgTop = this.$refs.slogan.getBoundingClientRect().top - 96;
      this.imgLeft =
        this.$refs.slogan.getBoundingClientRect().left +
        this.$refs.slogan.clientWidth / 2 -
        96;
      this.addedTriangles.push({
        style: {
          top: `${this.imgTop}px`,
          left: `${this.imgLeft}px`,
          zIndex: this.zIndex
        },
        src: this.triangles[2].image
      });
      this.imgTop = this.$refs.slogan.getBoundingClientRect().top + 48;
      this.imgLeft =
        this.$refs.slogan.getBoundingClientRect().left +
        this.$refs.slogan.clientWidth -
        192;
      this.addedTriangles.push({
        style: {
          top: `${this.imgTop}px`,
          left: `${this.imgLeft}px`,
          zIndex: this.zIndex
        },
        src: this.triangles[2].image
      });
      this.imgTop = this.$refs.avatar.getBoundingClientRect().top;
      this.imgLeft = this.$refs.avatar.getBoundingClientRect().left - 554;
      this.imgSize = this.$refs.avatar.clientWidth;
      this.addedTriangles.push({
        style: {
          top: `${this.imgTop}px`,
          left: `${this.imgLeft}px`,
          height: `${this.imgSize}px`,
          width: `auto`,
          zIndex: 4,
          opacity: 0.9
        },
        src: this.triangles[3].image
      });
      this.imgTop = this.$refs.avatar.getBoundingClientRect().top;
      this.imgLeft = this.$refs.avatar.getBoundingClientRect().right;
      this.imgSize = this.$refs.avatar.clientWidth;
      this.addedTriangles.push({
        style: {
          top: `${this.imgTop}px`,
          left: `${this.imgLeft}px`,
          height: `${this.imgSize}px`,
          width: `auto`,
          zIndex: 4,
          opacity: 0.9
        },
        src: this.triangles[4].image
      });
    }
  },
  mounted() {
    this.addTriangles();
  }
};
</script>

<style lang="scss" scoped>
.image {
  position: absolute;
}
.no-padding {
  padding: 0 !important;
}
.image-full-width {
  width: 100%;
  height: auto;
}
</style>
